<ng-template [ngIf]="type == 'label'">

  @if (useFloatLabel) {
    <i *ngIf="icon" [class]="icon + ' mr-1'"></i>
    <p-floatlabel [variant]="useFloatLabel">
      <input [class]="valueClass"
             [readOnly]="true"
             pInputText
             [(ngModel)]="internalModel"
             [style.width]="inputWidth"
             autocomplete="off">
      <label>{{ label }}</label>
    </p-floatlabel>
  } @else {
    <div class="p-inputgroup align-items-center" style="height: 32px">
      <i *ngIf="icon" [class]="icon + ' mr-1'"></i>
      <label *ngIf="hasLabel" [style.width]="labelWidth">{{ label }}</label>
      <span [style.width]="inputWidth" [class]="valueClass">{{ model }}</span>
    </div>
  }
</ng-template>

<ng-template #textInput>
  <label [for]="inputElementId" *ngIf="hasLabel" [style.width]="useFloatLabel ? 'auto' : labelWidth"
  [class.max-reached]="internalModelLength >= maxLength">{{ label }}</label>
  <input [class]="valueClass" [min]="minValue" [max]="maxValue"
         [class.ng-invalid]="internalModelLength < minLength"
         [disabled]="disabled" [readOnly]="readOnly"
         pInputText [type]="type" [(ngModel)]="internalModel"
         [maxlength]="ignoreMaxLength ? null : maxLength" [placeholder]="placeholder"
         [style.width]="inputWidth"
         [required]="required"
         [autocomplete]="autocomplete"
         (keyup.enter)="hasActionButton && this.action.emit(inputElement.value)"
         #inputElement [id]="inputElementId"
  >
  <button pButton class="p-inputgroup-addon" *ngIf="canBeRandomized"
          pTooltip="Genera testo casuale" tooltipPosition="top" appendTo="body"
          (click)="randomizeContent()">
    <span class="fas fa-dice"></span>
  </button>
  <span class="p-inputgroup-addon" *ngIf="showAddons">
            <ng-container *ngTemplateOutlet="customButtons"></ng-container>
            <span *ngIf="showLength && internalModel" pTooltip="N. di caratteri">
                {{ internalModelLength }}
              <ng-template [ngIf]="!ignoreMaxLength"> / {{ maxLength }}</ng-template>
            </span>
        </span>
  <app-action-button *ngIf="hasActionButton"
                     [disabled]="disabled || disabledActionButton"
                     [label]="actionButtonLabel"
                     [pTooltip]="actionButtonTooltip"
                     [type]="actionButtonType"
                     [textButton]="isActionTextButton"
                     (click)="this.action.emit(inputElement.value)"
  ></app-action-button>
</ng-template>

<ng-template [ngIf]="type == 'text' || type == 'number' || type == 'password'">
  <div class="p-inputgroup align-items-center" [class.flex]="fullWidth">
    <i *ngIf="icon" [class]="icon + ' mr-1'"></i>
    @if (useFloatLabel) {
      <p-floatlabel [variant]="useFloatLabel">
        <ng-container *ngTemplateOutlet="textInput"></ng-container>
      </p-floatlabel>
    } @else {
      <ng-container *ngTemplateOutlet="textInput"></ng-container>
    }
  </div>
</ng-template>

<ng-template [ngIf]="type == 'textarea'">
  <div class="p-inputgroup relative flex">
    <i *ngIf="icon" [class]="icon + ' mr-1'"></i>
    <label [for]="inputElementId" *ngIf="hasLabel" [style.width]="labelWidth"
           style="margin-top: 0.2rem" [class.max-reached]="internalModelLength >= maxLength">{{ label }}</label>
    <textarea #textarea pTextarea [autoResize]="autoresize"
              style="resize: none; overflow-y: auto"
              [disabled]="disabled" [readOnly]="readOnly"
              [(ngModel)]="internalModel"
              [maxlength]="ignoreMaxLength ? null : maxLength"
              [style.width]="fullWidth ? '100%' : inputWidth" [rows]="4"
              [required]="required" [class]="valueClass"
              [placeholder]="placeholder"
              #inputElement [id]="inputElementId"></textarea>
    <div *ngIf="showLength && internalModel" pTooltip="N. di caratteri" style="width: 120px">
              {{ internalModelLength }}
      <ng-template [ngIf]="!ignoreMaxLength"> / {{ maxLength }}</ng-template>
    </div>
    <!--
    <span class="p-inputgroup-addon place-top" *ngIf="showAddons" style="margin-bottom: 10px;">
    -->
        <!--
        <button *ngIf="showMaximizeTextareaButton" pButton pRipple class="p-button-text p-button-sm"
                  pTooltip="Mostra a pieno schermo" (click)="maximize()">
              <i class="pi pi-window-maximize"></i>
          </button>
          -->
    <!--
          <ng-container *ngTemplateOutlet="customButtons"></ng-container>
          <span *ngIf="showLength && internalModel" pTooltip="N. di caratteri">
              {{ internalModelLength }}
            <ng-template [ngIf]="!ignoreMaxLength"> / {{ maxLength }}</ng-template>
          </span>
    </span>
    -->

  </div>
</ng-template>

<p-dialog [header]="label.length > 0 ? label : 'Modifica testo'" [(visible)]="maximizedTextArea"
          *ngIf="showMaximizeTextareaButton"
          appendTo="body"
          [style]="{width: '80vw', height: '80hw'}">
    <textarea #textarea pTextarea [autoResize]="autoresize"
              [disabled]="disabled" [readOnly]="readOnly"
              [(ngModel)]="internalModel"
              [maxlength]="ignoreMaxLength ? null : maxLength"
              [rows]="30"
              style="width: 100%"
              [placeholder]="placeholder"
              #inputElement [id]="inputElementId"></textarea>
</p-dialog>

<ng-template [ngIf]="type == 'wysiwyg'">
  <div class="p-inputgroup">
    <i *ngIf="icon" [class]="icon + ' mr-1'"></i>
    <label [for]="inputElementId" *ngIf="hasLabel" [style.width]="labelWidth"
           style="margin-top: 0.2rem">{{ label }}</label>
    <p-editor
      [disabled]="disabled" [readonly]="readOnly"
      [(ngModel)]="internalModel"
      [maxlength]="ignoreMaxLength ? null : maxLength"
      [style.width]="inputWidth"
      [required]="required" [class]="valueClass"
      [placeholder]="placeholder"
    ></p-editor>
    <span class="p-inputgroup-addon" *ngIf="showLength && internalModel" pTooltip="N. di caratteri">
            {{ internalModelLength }}
      <ng-template [ngIf]="!ignoreMaxLength"> / {{ maxLength }}</ng-template>
        </span>
  </div>
</ng-template>

<ng-template [ngIf]="type == 'time'">
  <div class="p-inputgroup align-items-center">
    <i *ngIf="icon" [class]="icon + ' mr-1'"></i>
    <label [for]="inputElementId" *ngIf="hasLabel" [style.width]="labelWidth">{{ label }}</label>
    <input [class]="valueClass"
           [class.ng-invalid]="internalModelLength < minLength"
           [disabled]="disabled" [readOnly]="readOnly"
           pInputText [type]="type" [(ngModel)]="internalModel"
           [maxlength]="ignoreMaxLength ? null : maxLength" [placeholder]="placeholder"
           [style.width]="inputWidth"
           [required]="required"
           (keyup.enter)="hasActionButton && this.action.emit(inputElement.value)"
           #inputElement [id]="inputElementId"
    >
  </div>
</ng-template>

